module.exports = __webpack_public_path__ + "media/images/ic-image-87cb707d7809601684bd64def8fcaba7.png";